import {
  ApprovingOfficer,
  Result,
  Transaction,
  TransactionType,
} from "../models/interfaces";
import { BaseService } from "./BaseService";

export class TransactionService extends BaseService {
  async getTransactions(params: {
    fromDate?: Date;
    toDate?: Date;
    narration?: string;
    accountId?: number;
    pageIndex?: number;
    recordCount?: number;
    transactionTypeCode?: string;
  }): Promise<Result<Transaction[]>> {
    return this.get(`transactions`, params);
  }

  async getTransactionTypes(): Promise<Result<TransactionType[]>> {
    return this.get(`transactions/types`);
  }

  async reverseTransaction(params: {
    id: number;
    reason?: string;
  }): Promise<Result<Transaction>> {
    return this.post(`transactions/${params.id}/reverse`, params.reason);
  }

  async postManualTransaction(params: {
    useSameTransactionId?: boolean;
    transactionDetails: {
      accountId: number;
      amount: number;
      narration: string;
    }[];
  }): Promise<any> {
    return this.post(`transactions/manual-posting`, params);
  }

  async approveTransaction(params: {
    transactionId: number;
    status: boolean;
    remark?: string;
  }): Promise<Result<Transaction>> {
    const approvalMethod = params.status ? "approve" : "decline";
    return this.post(
      `transactions/${approvalMethod}/${params.transactionId}`,
      params.remark
    );
  }

  /**Gets users that can approve this transaction */
  async getApprovingOfficers(
    transactionId: number
  ): Promise<Result<ApprovingOfficer>> {
    return this.get<Result<ApprovingOfficer>>(
      `transactions/${transactionId}/approving-officers`
    );
  }

  /**Gets all users that have been marked as approving officers */
  async getAllApprovingOfficers(): Promise<Result<ApprovingOfficer>> {
    return this.get<Result<ApprovingOfficer[]>>(
      `transactions/approving-officers`
    );
  }

  async setApprovingOfficers(params: {
    transactionTypeCode: string;
    level: number;
    userId: number;
    minAmount: number;
    maxAmount: number;
  }): Promise<Result<boolean>> {
    return this.post(`transactions/approving-officers`, params);
  }

  async removeApprovingOfficers(id: number): Promise<Result<boolean>> {
    return this.delete(`transactions/approving-officers/${id}`);
  }
}

export default new TransactionService();
